<template>
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <div class="common-form">运费策略设置(未设置按商城设置)</div>
      <el-form-item label="运费组合策略">
        <div>
          <el-radio v-model="form.freightRule" :label="10">叠加</el-radio>
          <div class="tips">
            订单中的商品有多个运费模板时，将每个商品的运费之和订为订单总运费
          </div>

        </div>
        <div style="margin-top: 20px">
          <el-radio v-model="form.freightRule" :label="20">已低运费结算</el-radio>
          <div class="tips">
            订单中的商品有多个运费模板时，取订单中运费最少的商品的运费计为订单总运费
          </div>
        </div>
        <div style="margin-top: 20px">
          <el-radio v-model="form.freightRule" :label="30">已高运费结算</el-radio>
          <div class="tips">
            订单中的商品有多个运费模板时，取订单中运费最多的商品的运费计为订单总运费
          </div>
        </div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js'

export default {
  name: 'freight',
  data () {
    return {
      loading: false,
      form: {
        freightRule: '',
      },
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getSupplierShopFreightSetting()
    },
    getSupplierShopFreightSetting () {
      SettingApi.getSupplierFreightSetting({}, true).then(result => {
        this.form = result.data
      })
    },
    onSubmit () {
      let self = this
      let param = this.form
      if (!param.freightRule) {
        this.$message.info('请选择运费策略')
      }
      SettingApi.setSupplierFreightSetting(param, true).then(data => {
        self.$message({
          message: data.msg,
          type: 'success'
        })
        this.getSupplierShopFreightSetting()
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/setting/freight/index.vue